__webpack_require__.p = "/reports-manage-location-details/account-setup/";